import React from "react"
import PropTypes from "prop-types"
import CloseIcon from "../close-icon"
import { P } from "../typography"
import { Container } from "./styles"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleExclamation, faCircleCheck, faCircleInfo } from "@fortawesome/pro-solid-svg-icons"

const Alert = ({ options, message, close, simple = false }) => {
  const closeAlert = (event) => {
    event.preventDefault()
    if (close !== undefined) close()
  }
  const variant = options.type === "error" ? "" : "secondaryReadable"
  const alertStyle = simple ? "simple" : "default"
  return (
    <Container variant={options.type} alertStyle={alertStyle}>
      {simple && options.type == "error" && <FontAwesomeIcon icon={faCircleExclamation} size="lg" />}
      {simple && options.type == "success" && <FontAwesomeIcon icon={faCircleCheck} size="lg" />}
      {simple && !["success", "error"].includes(options.type) && <FontAwesomeIcon icon={faCircleInfo} size="lg" />}
      <P marginless variant={variant}>
        {message}
      </P>
      {!simple && <CloseIcon variant={variant} onClick={closeAlert} />}
    </Container>
  )
}

Alert.propTypes = {
  options: PropTypes.object.isRequired,
  message: PropTypes.string.isRequired,
  close: PropTypes.func.isRequired
}

Alert.defaultProps = {
  options: {},
  message: "",
  close: undefined
}

export default Alert
